module.exports = __webpack_public_path__ + "static/media/imageprocessing.75da944a.svg";